export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/market_research.0d3773f.svg";